/**
 * The `key` to use to interact with HTTP request page atoms when on routes that correspond
 * to the pattern `<document-id>/<page-slug>`.
 */
export function requestPageKeyForDocsRoute(params: { documentId: string; pageId: string }): string {
	const { documentId, pageId } = params;
	return `request-page::${documentId}/${pageId}`;
}
